import { AnyAction } from 'redux'
import { produce } from 'immer'

interface AlertState {
  folded: boolean
}

const initialState: AlertState = {
  folded: false
}

export const actions = {
  toggleFolded: 'collapsibleMenu/toggleFolded'
}

export function toggleFolded () {
  return { type: actions.toggleFolded }
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.toggleFolded:
      return produce(state, draft => {
        draft.folded = !draft.folded
      })
    default:
      return state
  }
}
